<template>
  <div
    ref="outerContainerRef"
    class="
      tw-flex tw-flex-col tw-gap-2 tw-rounded-lg tw-group tw-px-6 tw-relative
    "
    :class="[backgroundClasses, dimmedClasses, higlightedClasses, slimClasses]"
    @click.stop="handleClick"
  >
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

interface Props {
  dimmed?: boolean
  highlighted?: boolean
  subtleBackground?: boolean
  slim?: boolean
}

const { dimmed, highlighted, subtleBackground, slim } = defineProps<Props>()

const outerContainerRef = ref<HTMLElement | null>(null)

const emit =
  defineEmits<{
    click: [e: Event]
    clickOutside: [e: Event]
  }>()

const backgroundClasses = computed(() => ({
  'tw-bg-sf-snow-subtle': subtleBackground,
  'tw-bg-sf-snow-lighter': !subtleBackground,
}))

const dimmedClasses = computed(() => ({
  'tw-opacity-50': dimmed,
}))

const higlightedClasses = computed(() => ({
  'tw-border-sf-primary-dark': highlighted,
  'tw-shadow-highlight': highlighted,
  'tw-border-gray-300': !highlighted,
}))

const slimClasses = computed(() => ({
  'tw-border tw-border-solid tw-py-4': !slim,
  'hover:tw-bg-sf-snow-light tw-pt-4': slim,
}))

function handleClick(e: Event) {
  emit('click', e)
}

function handleClickOutside(e: Event) {
  if (highlighted) {
    emit('clickOutside', e)
  }
}

onClickOutside(outerContainerRef, handleClickOutside)
</script>
